import { cx } from "class-variance-authority";
import useRouterVariable from "../../../../components/utils/useRouterVariable";
import { useFetchOrgColor } from "../../../api-docs";

interface HeaderViewProps {
  leading?: React.ReactNode;
  trailing?: React.ReactNode;
  content?: React.ReactNode;
  accentColor?: string;
}
interface ConnectedHeaderProps {
  leading?: React.ReactNode;
  trailing?: React.ReactNode;
  content?: React.ReactNode;
}

const HeaderView = (props: HeaderViewProps) => {
  return (
    <header
      className={cx(
        "w-full z-10 row-span-1 shadow items-center h-full border-t-4",
        "border-transparent bg-white",
        "transition-all  duration-300"
      )}
      style={{
        borderColor: props?.accentColor ?? null,
      }}
    >
      <div className="grid grid-cols-[1fr,1fr] px-6 h-full w-full max-h-full max-w-[1280px] mx-auto">
        <div className="flex items-center gap-x-3">
          {props.leading}
          <span className="hidden md:flex h-full">{props.content}</span>
        </div>
        <div className="flex h-full">{props.trailing}</div>
      </div>
    </header>
  );
};

export const Header = (props: ConnectedHeaderProps) => {
  const org = useRouterVariable("org", (o) => o as string);
  const orgColor = useFetchOrgColor(
    {
      orgFriendlyName: org,
    },
    {
      query: {
        enabled: org != null,
      },
    }
  );

  return (
    <HeaderView
      leading={props.leading}
      trailing={props.trailing}
      content={props.content}
      accentColor={orgColor?.data}
    />
  );
};
